/* eslint-disable no-useless-escape */
export const RegexFields = {
    email: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$",
    personName: /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]*)$/,
    profileName: /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s][^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]*)$/,
    weakPassword: /^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*|[a-zA-Z0-9]*)$/i,
    phone: "^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$",
    zipCode: "^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$",
    tva: /^FR[\s]?([0-9]{2}[\s]?[0-9]{9})$/,
    expDate: /^(0[1-9]|10|11|12)\/20[0-9]{2}$/,
    cvv: /^[0-9]{3,4}$/
};
/* eslint-enable no-useless-escape */